<template>
  <b-card no-body class=" shadow border-0 p-3 mb-2 h-100">
    <b-row>
      <b-col sm="6">

        <b-form  class="">
          <h5 v-if="subtitle==''?false:true" class="text-primary">{{ subtitle }}</h5>
          <b-form-group
                  id="input-group-1"
                  label="姓名"
                  label-for="input-1"
                  description=""
          >
            <b-input-group  class="mb-2" label="姓名" >
            <b-form-input  v-model="formData.firstname"
                           type="text"
                           size="md"
                           required

                           maxlength="2"
                           @change="checkvalue('firstname')"
                           placeholder="ex:陳">

            </b-form-input>
            <b-form-input  v-model="formData.lastname"
                           type="text"
                           size="md"
                           required
                           maxlength="2"
                           @change="checkvalue('lastname')"
                           placeholder="ex:曉明">

            </b-form-input>


          </b-input-group>
            <b-form-invalid-feedback :state="formData.namecheck">
              {{ formData.namemsg }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="性別">
            <b-form-radio-group
                    v-model="formData.sex"
                    :options="maleoptions"
                    name="Name"
                    @input="checkvalue('male')"
            ></b-form-radio-group>
            <b-form-invalid-feedback :state="formData.malecheck">
              {{ formData.malemsg }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group  label="熟識程度" v-if="familiarFnu">
            <b-form-radio-group
                    v-model="formData.familiar"
                    :options="familiaroptions"
                    name="Familer"
                    @input="checkvalue('familer')"
            ></b-form-radio-group>
            <b-form-invalid-feedback :state="formData.familiarcheck">
              {{ formData.familiarmsg }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col v-if="true" class="d-none d-md-block text-center">
        <b-img v-if="formData.sex == 0" :src="require('../assets/ui/woman.jpg')" fluid alt="Responsive image" style="max-height: 200px" class=""></b-img>
        <b-img v-else :src="require('../assets/ui/man.jpg')" fluid alt="Responsive image" style="max-height: 200px" class=""></b-img>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {isch} from '@/service/commuse'

export default {
  name: 'FormCompareBox',
  components: {},

  props: {
    familiarFnu:Boolean,
    subtitle:String
  },
  data() {
    return {
      formData: {
        name:'',
        firstname:'',
        lastname:'',
        namemsg:'',
        namecheck:false,
        type: '',
        sex: '',
        malemsg:'',
        malecheck:false,
        familiar: '',
        familiarmsg: '',
        familiarcheck: false,
      },
      maleoptions: [
        {text: '男', value: '1'},
        {text: '女', value: '0'}
      ],
      familiaroptions: [
        {text: '熟識', value: '0'},
        {text: '不熟識', value: '1'}
      ],
    }
  },
  methods: {

    toggleModal(){
      this.checkvalue('firstname')
      this.checkvalue('lastname')
      this.checkvalue('male')
      this.checkvalue('all')

      if(this.familiarFnu){
        this.checkvalue('familer')
        if(
          this.formData.namecheck==true &&
          this.formData.malecheck == true &&
          this.formData.familiarcheck==true
        ){

          this.$emit('sendAction',this.formData);
        }
      }else{
        if(
          this.formData.namecheck==true &&
          this.formData.malecheck == true
        ){

          this.$emit('sendAction',this.formData);
        }
      }




    },
    checkvalue (way) {
      switch (way) {
        case 'firstname':
          this.formData.firstname= this.formData.firstname.trim()
          if (this.formData.firstname.length == 0 ) {
            this.formData.namemsg = '請輸入姓名'
            this.formData.namecheck = false
            return
          }

          if (!isch(this.formData.firstname)) {
            this.formData.namemsg = '請填寫中文姓名名字'
            this.formData.namecheck = false
            return

          }else{
            this.formData.namecheck = true
          }

          break
        case 'lastname':
          this.formData.lastname= this.formData.lastname.trim()
          if (this.formData.lastname.length == 0 ) {
            this.formData.namemsg = '請輸入姓名'
            this.formData.namecheck = false
            return
          }

          if (!isch(this.formData.lastname)) {
            this.formData.namemsg = '請填寫中文姓名名字'
            this.formData.namecheck = false
            return

          }else{
            this.formData.namecheck = true
          }

          break

        case 'male':
          if (this.formData.sex === '') {
            this.formData.malecheck = false
            this.formData.malemsg = '請選擇性別'
          }else{
            this.formData.malecheck = true
          }
          break
        case 'familer':
          if (this.formData.familiar === '') {
            this.formData.familiarcheck = false
            this.formData.familiarmsg = '請選擇熟識與否'
          }else{
            this.formData.familiarcheck = true
          }
          break
        case 'all':
          if (this.formData.firstname.length == 1 ) {
            this.formData.type='0'
            this.formData.name=this.formData.firstname+this.formData.lastname
          }
          if (this.formData.firstname.length == 2 ) {
            this.formData.type='1'
            this.formData.name=this.formData.firstname+this.formData.lastname
          }

          break;

      }

    },
  }
}
</script>
